import Api from "@/services/api.js";
import buffer from "@/store/modules/buffer.js";
// DATA COMPARTILHADA POR STORAGE
const rotaBufferMixin = {
  data() {
    return {
      buffer
    };
  },
  // FIM
  methods: {
    async chamadaRotaImpostos(rota, form, imposto) {
      // CRIA UM NOVO PAYLOAD PARA MODIFICAR
      let formModificado = { ...form };
      // VERIFICA SE NECESSIDA DE ALÍQUOTA SELECIONADA NO ICMS
      // PARA MANTER PADRÃO DE PAYLOAD E PODER COMPARAR COM O BUFFER
      let icmsNecessitaAliquota = ["icms_st", "carga_liquida", "antecipacao", "difal"];
      if (!icmsNecessitaAliquota.includes(imposto)) {
        delete formModificado.aliquotaIcmsSelecionada;
      }
      formModificado.regra = formModificado.regra.toString();
      // FIM
      // VERIFICA SE EXISTE PAYLOAD NO BUFFER
      const pay = JSON.stringify(formModificado);
      const [resultadoBuffer] = this.buffer.chamadaBuffer.filter(
        payload => payload.payload == pay && payload.rota == rota
      );
      // FIM
      // SE NÃO EXISTE RESULTADO NO BUFFER, CHAMA A ROTA, SALVA RESPOSTA EM BASE64 E ENVIA RESPOSTA
      if (!resultadoBuffer) {
        // try {
          const response = await new Api().post(rota, formModificado);
          this.buffer.chamadaBuffer.push({
            rota: rota,
            payload: pay,
            resposta: Buffer.from(JSON.stringify(response)).toString("base64")
          });
          return response;
        // } catch (error) {
        //   console.error(error);
        //   this.erro = true
        // }
        // FIM
      } else {
        // SE EXISTE RESULTADO NO BUFFER, REMOVE BASE64 E ENVIA RESPOSTA
        return JSON.parse(Buffer.from(resultadoBuffer.resposta, "base64"));
        // FIM
      }
    },

    async chamadaRota(rota, form) {
      // CRIA UM NOVO PAYLOAD PARA MODIFICAR
      let formModificado = { ...form };
      // VERIFICA SE NECESSIDA DE ALÍQUOTA SELECIONADA NO ICMS
      // PARA MANTER PADRÃO DE PAYLOAD E PODER COMPARAR COM O BUFFER
      formModificado.regra = formModificado.regra.toString();
      // FIM
      // VERIFICA SE EXISTE PAYLOAD NO BUFFER
      const pay = JSON.stringify(formModificado);
      const resultadoBufferFilter = this.buffer.chamadaBuffer.filter(
        payload => payload.rota == rota
      );
      const resultadoBufferFind = resultadoBufferFilter.find(payload => payload.payload == pay);
      // FIM
      // SE NÃO EXISTE RESULTADO NO BUFFER, CHAMA A ROTA, SALVA RESPOSTA EM BASE64 E ENVIA RESPOSTA
      if (!resultadoBufferFind) {
        // try {
          const response = await new Api().post(rota, form);
          this.buffer.chamadaBuffer.push({
            rota: rota,
            payload: pay,
            resposta: !!response.dados.length
              ? Buffer.from(JSON.stringify(response.dados[0])).toString("base64")
              : Buffer.from(JSON.stringify(response.dados)).toString("base64")
          });
          return !!response.dados.length ? response.dados[0] : response.dados;
        // } catch (error) {
        //   console.error(error);
        //   return
        // }
        // FIM
      } else {
        // SE EXISTE RESULTADO NO BUFFER, REMOVE BASE64 E ENVIA RESPOSTA
        return JSON.parse(Buffer.from(resultadoBufferFind.resposta, "base64"));
        // FIM
      }
    },

    // LIMPA O BUFFER
    limpaChamadaBuffer() {
      this.buffer.chamadaBuffer = [];
    }
    // FIM
  }
};

export default rotaBufferMixin;
